export default {
  BASE_URL: '/admin/crm/dynamic',
  api: [
    {
      name: 'pendList',
      desc: '未审核列表',
      method: 'POST',
      path: '/pending/list'
    },
    {
      name: 'auditList',
      desc: '已审核列表',
      method: 'POST',
      path: '/audit/list'
    },
    {
      name: 'detail',
      desc: '动态详情',
      method: 'GET',
      path: '/detail/{id}'
    },
    {
      name: 'audit',
      desc: '审核操作',
      method: 'POST',
      path: '/audit'
    },
    {
      name: 'show',
      desc: '是否显示',
      method: 'GET',
      path: '/show'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/business/review.js